{
  "consignes.agent.chargement": "Reading the agent role…",
  "consignes.agent.depot": "produces",
  "consignes.agent.deterministe": "Deterministic role: no agent instruction: role without a model.",
  "consignes.agent.droit": "right",
  "consignes.agent.legende": "Agent instructions of the role: version, status, model role, qualification proof, service",
  "consignes.agent.sansConsigne": "No agent instruction published for this agent role",
  "consignes.agent.versListe": "All platform agents",
  "consignes.agentDepot.architecte": "ADRs, constraints for developer agents",
  "consignes.agentDepot.designer": "versioned mock-ups",
  "consignes.agentDepot.eclaireuse": "context file",
  "consignes.agentDepot.garde": "reasoned verdicts",
  "consignes.agentDepot.greffiere": "evidence file, commits",
  "consignes.agentDepot.livreuse": "deployment, receipt",
  "consignes.agentDepot.ouvriere": "diff",
  "consignes.agentDepot.reine": "plan, registry",
  "consignes.agentDepot.reparatrice": "fix diff",
  "consignes.agentDepot.verificatriceConception": "test cases",
  "consignes.agentDepot.verificatriceExecution": "runs, evidence",
  "consignes.agentDroit.architecte": "read; write ADRs",
  "consignes.agentDroit.designer": "read; write mock-ups",
  "consignes.agentDroit.eclaireuse": "read only",
  "consignes.agentDroit.garde": "read only",
  "consignes.agentDroit.greffiere": "git write (single committer); write links",
  "consignes.agentDroit.livreuse": "deployment outside production; production requires human approval",
  "consignes.agentDroit.ouvriere": "write in the workspace only",
  "consignes.agentDroit.reine": "read everything; write registries and assignments",
  "consignes.agentDroit.reparatrice": "write in the workspace",
  "consignes.agentDroit.verificatriceConception": "read; write tests",
  "consignes.agentDroit.verificatriceExecution": "sandboxed execution, no code writing",
  "consignes.agentRole.architecte": "proposes technical options, gets them decided, records the decision",
  "consignes.agentRole.designer": "proposes screen flows, mock-ups, style guide",
  "consignes.agentRole.eclaireuse": "gathers context: repository map, specification, decisions, history",
  "consignes.agentRole.garde": "judges: code review (another model family), threats, compliance, specification quality control",
  "consignes.agentRole.greffiere": "keeps the evidence file, links requirement, test, defect and commit; only one to commit",
  "consignes.agentRole.livreuse": "builds the image, deploys to preview, rolls back",
  "consignes.agentRole.ouvriere": "writes the code of a feature",
  "consignes.agentRole.reine": "breaks the mission into a task graph, keeps the registries, routes, replans, escalates",
  "consignes.agentRole.reparatrice": "fixes a defect: reproduction test first, targeted diff",
  "consignes.agentRole.verificatriceConception": "writes the tests of a requirement, hidden from developer agents",
  "consignes.agentRole.verificatriceExecution": "runs tests, start-up and browser journeys in the sandbox",
  "consignes.agents.avecModele": "with a model",
  "consignes.agents.chargement": "Reading the platform agents…",
  "consignes.agents.deterministe": "deterministic",
  "consignes.agents.legende": "Agent roles: role, determinism, agent instructions in service and qualification proof",
  "consignes.agents.sansCatalogue": "No catalogue published — agent roles are listed without their agent instructions. Start the worker on the GPU host.",
  "consignes.agents.titre": "Platform agents",
  "consignes.agents.vide": "No agent role declared",
  "consignes.ancien": "This catalogue was published {{age}} ago: the worker no longer republishes it. Agent instructions and their qualification may have changed since.",
  "consignes.caste.architecte": "architect agent",
  "consignes.caste.designer": "design agent",
  "consignes.caste.eclaireuse": "context agent",
  "consignes.caste.garde": "reviewer agent",
  "consignes.caste.greffiere": "evidence file agent",
  "consignes.caste.livreuse": "delivery agent",
  "consignes.caste.ouvriere": "developer agent",
  "consignes.caste.reine": "planner agent",
  "consignes.caste.reparatrice": "repair agent",
  "consignes.caste.verificatriceConception": "verifier agent (test design)",
  "consignes.caste.verificatriceExecution": "verifier agent (test execution)",
  "consignes.changement.ajoute": "added",
  "consignes.changement.inchange": "unchanged",
  "consignes.changement.modifie": "modified",
  "consignes.changement.retire": "removed",
  "consignes.choix.a": "To version",
  "consignes.choix.aucune": "— choose —",
  "consignes.choix.comparer": "Compare",
  "consignes.choix.de": "From version",
  "consignes.choix.indice": "Choose the two versions to compare.",
  "consignes.col.action": "action",
  "consignes.col.chemin": "path",
  "consignes.col.confiance": "trusted base",
  "consignes.col.consigne": "agent instruction",
  "consignes.col.consignes": "agent instructions in service",
  "consignes.col.date": "date",
  "consignes.col.demandeur": "requested by",
  "consignes.col.empreinte": "digest",
  "consignes.col.erreur": "error",
  "consignes.col.essai": "run",
  "consignes.col.etat": "state",
  "consignes.col.fichiers": "files",
  "consignes.col.modele": "model",
  "consignes.col.nature": "kind",
  "consignes.col.nom": "name",
  "consignes.col.origine": "origin",
  "consignes.col.preuve": "proof",
  "consignes.col.provenance": "file:line",
  "consignes.col.publie": "published",
  "consignes.col.role": "role",
  "consignes.col.roleAgent": "agent role",
  "consignes.col.roleModele": "model role → model",
  "consignes.col.score": "score",
  "consignes.col.service": "service",
  "consignes.col.statut": "status",
  "consignes.col.taille": "size",
  "consignes.col.verdict": "verdict",
  "consignes.col.version": "version",
  "consignes.comparer.aucune": "No difference between these two versions.",
  "consignes.comparer.bloc": "{{chemin}}, lines {{de}} to {{a}}",
  "consignes.comparer.chargement": "Reading the difference…",
  "consignes.comparer.composantes": "Qualification subject components touched",
  "consignes.comparer.fonctionnelSeul": "No raw file of the version differs, but the qualification subject changes (resolved text or include graph): see below.",
  "consignes.comparer.fragment": "The shared fragment changed: the qualification proof of the agent instructions that include it would be stale.",
  "consignes.comparer.inchanges": "Unchanged files ({{n}})",
  "consignes.comparer.inverser": "Swap",
  "consignes.comparer.lignes": "{{plus}} line(s) added, {{moins}} removed",
  "consignes.comparer.manquant": "Difference unavailable: content cited by the catalogue but not stored.",
  "consignes.comparer.nonPublie": "Difference unavailable: file not published (over 1 MiB, not UTF-8 or excluded).",
  "consignes.comparer.sens": "from {{de}} ({{oDe}}) to {{a}} ({{oA}})",
  "consignes.comparer.titre": "Compare two versions of {{nom}}",
  "consignes.comparer.tropGrand": "File too long for a line-by-line comparison (over 20,000 lines, or edit distance beyond 2,000).",
  "consignes.composante.carte": "agent instruction parameters (lifecycle excluded)",
  "consignes.composante.inclusions": "include graph",
  "consignes.composante.injection": "injection cases",
  "consignes.composante.reference": "reference cases",
  "consignes.composante.schemaEntree": "input schema",
  "consignes.composante.schemaSortie": "output schema",
  "consignes.composante.systeme": "served system text (resolved system.md)",
  "consignes.composante.tache": "served task text (resolved task.md)",
  "consignes.confiance.dans": "in the trusted base",
  "consignes.confiance.hors": "outside the trusted base",
  "consignes.correlation.autrePublication": "The qualification comes from another publication (another worker cycle): it is not related to the text shown.",
  "consignes.correlation.autreWorker": "The qualification comes from another publication (another worker): it is not related to the text shown.",
  "consignes.correlation.registreAbsent": "No snapshot of the agent instruction registry cites this agent instruction: its qualification is unknown.",
  "consignes.correlation.texteChange": "The served text changed since the qualification, at a constant version: the qualification proof no longer matches the text shown.",
  "consignes.demande.approuvee": "approved",
  "consignes.demande.attente": "awaiting approval",
  "consignes.demande.refusee": "refused",
  "consignes.demande.retiree": "withdrawn",
  "consignes.demandes.legende": "Promotion requests of the agent instruction",
  "consignes.demandes.versRegistre": "Promote: from the agent instruction registry",
  "consignes.demandes.vide": "No promotion request for this agent instruction",
  "consignes.divergence": "The catalogue was republished during reading: this content does not match the publication shown. It is not displayed.",
  "consignes.e0.absent": "Agent instruction catalogue not published: text, versions and texts outside cards will appear once the worker publishes it.",
  "consignes.e0.admissibilite": "Computed eligibility, not observed usage.",
  "consignes.e0.chargement": "Reading the agent instruction catalogue…",
  "consignes.e0.erreur": "The agent instruction catalogue could not be read; the registry below is still shown.",
  "consignes.e0.inconnu": "unknown ({{n}} agent instruction(s) with unknown eligibility)",
  "consignes.e0.refus": "The agent instruction catalogue is reserved to platform administration.",
  "consignes.e0.sansPreuve": "Agent instructions served without a qualification proof:",
  "consignes.e0.usage": "Usage served by the worker: {{usage}}.",
  "consignes.erreur": "The agent instruction catalogue could not be read.",
  "consignes.etatTexte.absent": "missing from the file",
  "consignes.etatTexte.illisible": "unreadable",
  "consignes.etatTexte.nonLitteral": "not a literal",
  "consignes.etatTexte.nonPubliable": "not publishable",
  "consignes.etatTexte.tropGrand": "too large",
  "consignes.etatTexte.trouve": "found",
  "consignes.famille.coeurIa": "core-ia prompts",
  "consignes.famille.intention": "Intent constants",
  "consignes.famille.partage": "Shared fragment",
  "consignes.famille.piles": "Stack rules",
  "consignes.fiche.admissibilite": "The service state is an eligibility computed from the worker rule, not observed usage.",
  "consignes.fiche.appelants": "called by",
  "consignes.fiche.basculeBrut": "Raw text (includes not expanded)",
  "consignes.fiche.chargement": "Reading the agent instruction…",
  "consignes.fiche.chargementVersion": "Reading the current version…",
  "consignes.fiche.etiquetteResolu": "{{nom}} (resolved)",
  "consignes.fiche.inclusions": "Includes: {{liste}}",
  "consignes.fiche.legendeVersions": "Versions of the agent instruction, origin, files and size",
  "consignes.fiche.onglets": "Agent instruction sections",
  "consignes.fiche.parametresVide": "No parameter file in the current version",
  "consignes.fiche.resoluErreur": "The resolved text is not published ({{code}}): the raw text is shown.",
  "consignes.fiche.roleAgent": "agent role",
  "consignes.fiche.sansFichier": "No {{nom}} file in this version.",
  "consignes.fiche.schemasVide": "No schema in the current version",
  "consignes.fiche.suitesVide": "No case suite in the current version",
  "consignes.fiche.version": "version {{v}}",
  "consignes.fiche.versionsVide": "No version published for this agent instruction",
  "consignes.filAriane": "Back",
  "consignes.fonctionnel.inconnu": "bytes changed (normalised subject not recomputed)",
  "consignes.fonctionnel.non": "bytes changed, served text identical",
  "consignes.fonctionnel.oui": "the served text changes",
  "consignes.introuvable.agent": "This agent role does not exist in the published catalogue.",
  "consignes.introuvable.consigne": "This agent instruction does not exist in the published catalogue.",
  "consignes.introuvable.fichier": "This file does not exist in the published version.",
  "consignes.introuvable.texte": "This text does not exist in the published catalogue.",
  "consignes.introuvable.version": "This version does not exist in the published catalogue.",
  "consignes.lecteur.chargement": "Reading the content…",
  "consignes.lecteur.erreurLecture": "This content could not be read.",
  "consignes.lecteur.manquant": "The catalogue cites this content but does not store it yet: the worker will publish it at its next cycle.",
  "consignes.lecteur.nonPublie": "This content is not published (too large, not UTF-8, excluded or not resolved).",
  "consignes.nature.autre": "other",
  "consignes.nature.carte": "parameters",
  "consignes.nature.journal": "changelog",
  "consignes.nature.partage": "shared fragment",
  "consignes.nature.schema": "schema",
  "consignes.nature.suite": "case suite",
  "consignes.nature.texte": "text",
  "consignes.nonPublie.exclu": "File not published: excluded from publication ({{code}}).",
  "consignes.nonPublie.nonUtf8": "File not published: content is not UTF-8, metadata only.",
  "consignes.nonPublie.tropGrand": "File not published: over 1 MiB, metadata only.",
  "consignes.onglet.demandes": "Requests",
  "consignes.onglet.parametres": "Parameters",
  "consignes.onglet.qualification": "Qualification",
  "consignes.onglet.schemas": "Schemas",
  "consignes.onglet.suites": "Suites",
  "consignes.onglet.texte": "Text",
  "consignes.onglet.versions": "Versions",
  "consignes.origine.courante": "current",
  "consignes.origine.instantane": "snapshot",
  "consignes.origineInvalide": "Invalid address: a version origin is “current” or “snapshot”.",
  "consignes.parametreManquant": "Incomplete address: the object to show is not specified",
  "consignes.parametreManquantIndice": "Open it from the agent instruction registry.",
  "consignes.preuve.absente": "never qualified",
  "consignes.preuve.perimee": "stale qualification proof",
  "consignes.preuve.valide": "valid qualification proof",
  "consignes.publication": "Catalogue published by {{worker}} {{age}} ago ({{quand}}), revision {{rev}}, served usage {{usage}}.",
  "consignes.qualif.le": "qualified on {{quand}}",
  "consignes.qualif.legende": "Qualification reports: run, date, model, score, verdict",
  "consignes.qualif.limite": "The qualification is related to the text shown through the digests of the resolved texts; schemas and suites enter the subject in normalised form, not compared here.",
  "consignes.qualif.modele": "model role → model",
  "consignes.qualif.promouvable": "promotable",
  "consignes.qualif.refuse": "refused",
  "consignes.qualif.repli": "fallback {{modele}}",
  "consignes.qualif.sansRapport": "No qualification report for this version.",
  "consignes.qualif.suites": "suites",
  "consignes.qualif.suitesValeur": "{{reference}} reference cases, {{injection}} injection cases",
  "consignes.refus": "Agent instructions and roles: access reserved to platform administration.",
  "consignes.relire": "Reread the screen",
  "consignes.resume.ajoutes": "{{n}} added",
  "consignes.resume.inchanges": "{{n}} unchanged",
  "consignes.resume.modifies": "{{n}} modified",
  "consignes.resume.retires": "{{n}} removed",
  "consignes.retour": "← Agent instructions and roles",
  "consignes.retourRegistre": "Back to the agent instruction registry",
  "consignes.roleModele.code": "code (primary)",
  "consignes.roleModele.general": "general",
  "consignes.roleModele.independant": "independent reviewer",
  "consignes.roleModele.raisonnement": "reasoning reviewer",
  "consignes.roleModele.rapide": "fast utility",
  "consignes.sansContenu.absent": "This name is no longer in the file: the declared inventory has drifted. No content is published.",
  "consignes.sansContenu.autre": "No content published for this text (state: {{etat}}).",
  "consignes.sansContenu.nonLitteral": "This expression is not a literal text (f-string, call, attribute): no content is published.",
  "consignes.service.avecPreuve": "served with a qualification proof",
  "consignes.service.inconnu": "unknown eligibility",
  "consignes.service.refusee": "refused by the worker",
  "consignes.service.sansAppelant": "no caller",
  "consignes.service.sansPreuve": "served without a qualification proof",
  "consignes.statut.active": "active",
  "consignes.statut.candidate": "on trial",
  "consignes.statut.deprecated": "deprecated",
  "consignes.statut.draft": "draft",
  "consignes.texte.chargement": "Reading the text…",
  "consignes.texte.etiquette": "Content of {{nom}}",
  "consignes.texte.famille": "family",
  "consignes.texte.provenance": "origin",
  "consignes.texte.versListe": "All texts outside cards",
  "consignes.textes.chargement": "Reading the texts outside cards…",
  "consignes.textes.intro": "Texts sent to the model outside agent instructions: intent constants, stack rules, core-ia prompts and the shared fragment. Read only.",
  "consignes.textes.legende": "Texts of the family: file and line, name, state, size, trusted base",
  "consignes.textes.limite": "Limit: a text written inline in a function, rather than as a named constant, is not inventoried here; the full inventory of texts sent to the model belongs to a later package.",
  "consignes.textes.ouvrir": "Open",
  "consignes.textes.ouvrirNom": "Open {{nom}}",
  "consignes.textes.titre": "Texts outside cards",
  "consignes.textes.vide": "No text outside cards in the published catalogue",
  "consignes.unite.kio": "{{n}} KiB",
  "consignes.unite.mio": "{{n}} MiB",
  "consignes.unite.octets": "{{n}} B",
  "consignes.versAgents": "Platform agents",
  "consignes.versTextes": "Texts outside cards ({{n}})",
  "consignes.version.chargement": "Reading the version…",
  "consignes.version.choisir": "Choose a file to read it.",
  "consignes.version.comparerCourante": "Compare with the current version",
  "consignes.version.fichierAbsent": "This file does not exist in this version.",
  "consignes.version.legende": "Files of the version: path, kind, size, digest, publication",
  "consignes.version.publie": "yes",
  "consignes.version.resoluNonPublie": "resolved {{nom}}: not published ({{code}})",
  "consignes.version.resoluPublie": "resolved {{nom}}: published",
  "consignes.version.sansFichier": "This version is published without files ({{code}}).",
  "consignes.version.titre": "{{nom}} — version {{v}}",
  "consignes.vide": "No catalogue published — start the worker on the GPU host",
  "consignes.videIndice": "The worker publishes the agent instruction catalogue when it starts, then every 5 minutes.",
  "consignes.voirConsigne": "View the agent instruction"
}
